import React, { Component, createRef } from "react";

import "./chatContent.css";
import Avatar from "../chatList/Avatar";
import ChatItem from "./ChatItem";

import {
  arrayUnion,
  doc,
  updateDoc,
  onSnapshot,
  getDoc,
  setDoc,
  deleteDoc,
  arrayRemove
} from "firebase/firestore"
import { db, storage } from "../../../firebase"
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage"

export default class ChatContent extends Component {

  selectedUser = {
    username: "Capacity",
    datetime: "Sat Sep 17 2022 00:26:44 GMT+0530 (India Standard Time)",
    user_id: "VwdLXhyGiWrIBVAAGmkp",
    userType: "Eyewear tech"
  }

  loggedUser = {
    username: "Zendaya",
    datetime: "Sat Sep 17 2022 00:25:22 GMT+0530 (India Standard Time)",
    user_id: "qTuXC1hFRpUs8pY6J4z8",
    userType: "influencer"
  }



  messagesEndRef = createRef(null);
  chatItms = [
    {
      key: 1,
      image:
        "https://media.istockphoto.com/photos/passport-picture-of-a-laughing-turkish-businesswoman-picture-id856597542?k=6&m=856597542&s=170667a&w=0&h=XkdCXs5QPN6mwQi4a75QLQlFBt_u3T9Rp9CgRyPwJQ4=",
      type: "",
      msg: "Hi Tim, How are you?",
    },
    {
      key: 2,
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTA78Na63ws7B7EAWYgTr9BxhX_Z8oLa1nvOA&usqp=CAU",
      type: "other",
      msg: "I am fine.",
    },
    {
      key: 3,
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTA78Na63ws7B7EAWYgTr9BxhX_Z8oLa1nvOA&usqp=CAU",
      type: "other",
      msg: "What about you?",
    },
    {
      key: 4,
      image:
        "https://media.istockphoto.com/photos/passport-picture-of-a-laughing-turkish-businesswoman-picture-id856597542?k=6&m=856597542&s=170667a&w=0&h=XkdCXs5QPN6mwQi4a75QLQlFBt_u3T9Rp9CgRyPwJQ4=",
      type: "",
      msg: "Awesome these days.",
    },
    {
      key: 5,
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTA78Na63ws7B7EAWYgTr9BxhX_Z8oLa1nvOA&usqp=CAU",
      type: "other",
      msg: "Finally. What's the plan?",
    },
    {
      key: 6,
      image:
        "https://media.istockphoto.com/photos/passport-picture-of-a-laughing-turkish-businesswoman-picture-id856597542?k=6&m=856597542&s=170667a&w=0&h=XkdCXs5QPN6mwQi4a75QLQlFBt_u3T9Rp9CgRyPwJQ4=",
      type: "",
      msg: "what plan mate?",
    },
    {
      key: 7,
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTA78Na63ws7B7EAWYgTr9BxhX_Z8oLa1nvOA&usqp=CAU",
      type: "other",
      msg: "I'm taliking about the tutorial",
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      // chat: this.chatItms,
      chat: [],
      msg: "",
      media: {
        file: '',
        fileType: ''
      },
      percent: 0,
    };
  }
  chat_Id = (this.loggedUser.user_id > this.selectedUser.user_id) ? (this.loggedUser.user_id + this.selectedUser.user_id) : (this.selectedUser.user_id + this.loggedUser.user_id)
  getConversation = async () => {
    const res = await getDoc(doc(db, "chats", this.chat_Id));
    if (res.exists()) {
      // console.log("Fetching Conversation...")
      //setConversation([])
      const unsub = onSnapshot(doc(db, "chats", this.chat_Id), (newdoc) => {
        if (newdoc.data().messages) {

          this.setState({ chat: newdoc.data().messages })
        }
      })
      return () => unsub();
    }
  }

  handleMediaChange = (e) => {
    const file = e.target.files[0]
    this.setState({ media: { file: file, fileType: file.type } })
  }

  async sendMessage(e, messageObject) {
    e.preventDefault()
    const res = await getDoc(doc(db, "chats", this.chat_Id))
    if (!res.exists()) {
      await setDoc(doc(db, "chats", this.chat_Id), { messages: [] });
      this.getConversation()
      // console.log("created")
    }

    console.log("Message: ", messageObject)

    if (this.state.media.file) {
      const storageRef = ref(storage, `/files/${Date.now()}-${messageObject.media.file.name}`)
      const uploadTask = uploadBytesResumable(storageRef, messageObject.media.file)
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );

          // update progress
          this.setState({ percent: percent })
          
        },
        (err) => console.log("unable to upload file: ", err),
        () => {
          // download url
          getDownloadURL(uploadTask.snapshot.ref).then(async (url) => {
            await updateDoc(doc(db, "chats", this.chat_Id), {
              messages: arrayUnion({
                messsage_id: `${Date.now()}`,
                message: messageObject.msg,
                from: this.loggedUser.user_id,
                to: this.selectedUser.user_id,
                datetime: `${new Date()}`,
                mediaURL: url,
                mediaType: messageObject.media.fileType
              }),
            });
            // console.log("updated")
            this.setState({ media: { file: '', fileType: '' } })
          });
        }
      );
    } else {
      // console.log("After: ", this.state.msg)
      await updateDoc(doc(db, "chats", this.chat_Id), {
        messages: arrayUnion({
          messsage_id: `${Date.now()}`,
          message: messageObject.msg,
          from: this.loggedUser.user_id,
          to: this.selectedUser.user_id,
          datetime: `${new Date()}`,
          mediaURL: '',
          mediaType: messageObject.media.fileType
        }),
      })
      
    }
    this.setState({ msg: '' })
  }

  deleteChat = async () => {
    await deleteDoc(doc(db, "chats", this.chat_Id))
  }

  // Entire message object should be passed
  deleteMsg = async (msg) => {
    await updateDoc(doc(db, `chats`, this.chat_Id), {
      messages: arrayRemove(msg)
    })
  }




  scrollToBottom = () => {
    this.messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
  };

  componentDidMount() {
    window.addEventListener("keydown", (e) => {
      if (e.keyCode == 13) {
        if (this.state.msg || this.state.media.file) {
          /* this.chatItms.push({
            key: 1,
            type: "",
            msg: this.state.msg,
            image:
              "https://pbs.twimg.com/profile_images/1116431270697766912/-NfnQHvh_400x400.jpg",
          }); */
          // this.setState({ chat: [...this.chatItms] });
          //console.log("Before: ", this.state.msg)
          this.sendMessage(e, this.state)
          this.scrollToBottom();
          this.setState({ msg: "" });

        }
      }
    });
    this.scrollToBottom();
    this.getConversation()
  }
  onStateChange = (e) => {
    this.setState({ msg: e.target.value })
  };

  render() {
    return (
      <div className="main__chatcontent">
        <div className="content__header">
          <div className="blocks">
            <div className="current-chatting-user">
              <Avatar
                isOnline="active"
                image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTA78Na63ws7B7EAWYgTr9BxhX_Z8oLa1nvOA&usqp=CAU"
              />
              <p>Tim Hover</p>
            </div>
          </div>

          <div className="blocks">
            <div className="settings">
              <button className="btn-nobg">
                <i className="fa fa-cog"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="content__body">
          <div className="chat__items">
            {console.log(this.state.chat)}
            {this.state.chat.map((msg, index) => {
              return (
                <ChatItem
                  animationDelay={index + 2}
                  key={msg.message_id}
                  user={msg.from !== this.loggedUser.user_id ? "other" : "me"}
                  msg={msg.message}
                  mediaType={msg.mediaType}
                  mediaURL={msg.mediaURL}
                  image={"https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTA78Na63ws7B7EAWYgTr9BxhX_Z8oLa1nvOA&usqp=CAU"}
                />
              );
            })}
            <div ref={this.messagesEndRef} />
          </div>
        </div>
        <div className="content__footer">
          <div className="sendNewMessage">
            <input type="file" name="addFiles" id="addMedia" onChange={this.handleMediaChange} hidden style={{cursor: "pointer"}}/>
            <label htmlFor="addMedia" className="addFiles" style={{cursor: "pointer"}}><i className="fa fa-plus"></i></label>
            
            <input
              type="text"
              placeholder="Type a message here"
              onChange={this.onStateChange}
              value={this.state.msg}
            />
            <button className="btnSendMsg" id="sendMsgBtn" onClick={(e)=> this.sendMessage(e, this.state)}>
              <i className="fa fa-paper-plane"></i>
            </button>
          </div>
        </div>
      </div>
    );
  }
}
